import { styled, Box, Typography } from "@mui/material";
import { buttonClasses } from "@mui/material/Button";
import { StyledLink } from "react-common-ui-library";
import { DISABLED } from "../../../Constants/CommonConstants";

export const StyledVerifyAccountBackBox = styled(Box)(() => ({
  width: "40px",
  display: "flex",
  aalignItems: "flexStart",
}));

export const StyledResendOTPLinkBox = styled(Box)(() => ({
  display: "inline-block",
}));

export const StyledVerifyAccountButtonBox = styled(Box)(({ theme }) => ({
  justifyContent: "center",
  display: "flex",

  [`& .${buttonClasses.root}`]: {
    minWidth: "60%",
    marginTop: "40px",
  },
  [theme.breakpoints.down("sm")]: {
    [`& .${buttonClasses.root}`]: {
      minWidth: "100%",
    },
  },
}));

export const StyledResendOTPLink = styled(StyledLink, {
  shouldForwardProp: (prop) => prop !== "linkType",
})(({ linkType }) => ({
  display: "inline-block",
  cursor: linkType === DISABLED ? "default" : "pointer",
}));

export const StyledAlternateVerificationMethodLink = styled(StyledLink, {
  shouldForwardProp: (prop) => prop !== "linkType",
})(({ linkType }) => ({
  cursor: linkType === DISABLED ? "default" : "pointer",
}));

export const StyledResendOTPHelperText = styled(Typography)(({ theme }) => ({
  display: "inline",
  fontStyle: "italic",
  marginLeft: "8px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "12px",
    display: "inline-block",
    marginLeft: 0,
  },
}));
